import {
  OrderTableData,
  PaymentType,
  UserRole,
} from '../../../OrdersPage/types';
import {
  formatTime,
  getFromLocalStorage,
  setToLocalStorage,
} from '../../../../global/helpers';
import { WoltCancelPayload } from '../../types';
import {
  WOLT_CANCEL_NETWORK_TAG_ID,
  WOLT_CANCEL_SENT_AT_KEY,
  WOLT_CANCEL_SENT_AT_TTL_MS,
  WOLT_CANCEL_SOURCE_TAG_ID,
} from './constants';

// Тег включён на аптеке (source) или на сети (network)
const hasWoltCancelTag = (data: OrderTableData): boolean =>
  Boolean(
    data?.sourceTags?.some((tag) => tag.id === WOLT_CANCEL_SOURCE_TAG_ID) ||
      data?.networkTags?.some((tag) => tag.id === WOLT_CANCEL_NETWORK_TAG_ID)
  );

// Кнопка доступна только фармацевту, на Wolt-заказах и при наличии тега
export const canRequestWoltCancel = (
  role: string,
  data: OrderTableData
): boolean =>
  role === UserRole.PHARMACIST &&
  (data?.paymentType === PaymentType.WOLT ||
    data?.userSource === 'wolt_user') &&
  hasWoltCancelTag(data);

// Отметка времени успешной отправки запроса по конкретному заказу
export const getWoltCancelSentAt = (orderId: string): string => {
  const stored: Record<string, string> =
    getFromLocalStorage(WOLT_CANCEL_SENT_AT_KEY) ?? {};
  return stored[orderId] ?? '';
};

export const saveWoltCancelSentAt = (orderId: string, sentAt: string): void => {
  const stored: Record<string, string> =
    getFromLocalStorage(WOLT_CANCEL_SENT_AT_KEY) ?? {};
  const minTime = new Date(sentAt).getTime() - WOLT_CANCEL_SENT_AT_TTL_MS;
  const actual: Record<string, string> = {};
  Object.keys(stored).forEach((key) => {
    if (new Date(stored[key]).getTime() > minTime) {
      actual[key] = stored[key];
    }
  });
  actual[orderId] = sentAt;
  setToLocalStorage(WOLT_CANCEL_SENT_AT_KEY, actual);
};

// formatTime отдаёт «20.08.2026 12:03», в плашке нужен обратный порядок
export const formatWoltCancelSentAt = (sentAt: string): string => {
  const [date, time] = formatTime(sentAt).split(' ');
  return `${time} ${date}`;
};

// 3-значный код заказа Wolt из комментария клиента, напр. Код заказа: 577
export const extractWoltCode = (comment?: string): string => {
  const match = comment?.match(/Код заказа[:№\s]*(\d+)/i);
  return match?.[1] ?? '';
};

// Payload для bridge-сервиса отмены.
// Код заказа Wolt bridge достаёт сам из order.comment
export const buildWoltCancelPayload = (
  data: OrderTableData,
  pharmacistNumber: string,
  cancellationReason: string
): WoltCancelPayload => ({
  autoProcess: true,
  order: {
    order_number: data.id,
    payment_method: data.paymentType ?? PaymentType.WOLT,
    user_source: data.userSource ?? '',
    comment: data.comment ?? '',
  },
  source: {
    name: data.sourceName ?? '',
    address: data.sourceAddress ?? '',
  },
  pharmacist: {
    number: pharmacistNumber,
  },
  cancellationReason,
});
